import "./IconSortFilterV2.scss";

type IconSortFilterV2Props = {
  width?: string;
  height?: string;
  direction?: "asc" | "desc";
  disabled?: boolean;
  variant?: "default" | "indigo" | "disabled";
};

export const IconSortFilterV2 = ({
  width = "1.25rem",
  height = "1.25rem",
  direction = "asc",
  disabled = false,
  variant = "default",
}: IconSortFilterV2Props) => {
  const disabledClass = disabled || variant === "disabled" ? " icon-sort-filter-v2--disabled" : "";
  const variantClass = variant === "indigo" ? " icon-sort-filter-v2--indigo" : "";
  return (
    <span
      className={`icon-sort-filter-v2 icon-sort-filter-v2--${direction}${disabledClass}${variantClass}`}
      style={{ width, height }}
      data-testid="icon-sort-filter-v2"
    ></span>
  );
};
